<template>
    <div>
        <PricingFilterToolbar
            :search-term="searchTerm"
            :expired-filter="expiredFilter"
            search-placeholder="Search by Name..."
            search-min-width="280px"
            @search-change="searchTerm = $event"
            @expired-filter-change="expiredFilter = $event"
        >
            <template v-slot:actions>
                <button v-if="userEditRight" type="button" @click="addPackage()" class="btn btn-info mr-3 mb-2">Add Package</button>
            </template>
        </PricingFilterToolbar>
        <div class="row row-spacing">
            <div class="col-md-12">
                <div class="table-responsive table-bordered" v-if="packages.length > 0">
                    <table class="table pricing-table">
                        <thead>
                            <tr class="text-nowrap">
                                <th class="pricing-column-description">Description</th>
                                <th class="pricing-column-price">NRC (excl. VAT)</th>
                                <th class="pricing-column-price">MRC (excl. VAT)</th>
                                <th class="pricing-column-price">MRC (incl. VAT)</th>
                                <th class="pricing-column-status">Expired</th>
                                <th v-if="userEditRight" class="pricing-column-actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :class="{ 'bg-primary': p.expired }" v-for="p in packages" :key="p.deviceManagementPackageNumber">
                                <td>
                                    {{p.label}}
                                </td>
                                <td class="text-nowrap">
                                  {{
                                    getSetupFee(p.prices,period)
                                  }}
                                </td>
                                <td>
                                    {{getPrice(p.prices, period)}}
                                </td>
                                <td>
                                    {{getPrice(p.prices, period, true)}}
                                    <span v-if="userEditRight" style="cursor: pointer" v-tooltip="'Edit Row Price'" @click="openPriceModal(p)"
                                        class="pull-right">
                                        <em class="fa fa-edit fa-fw text-green"></em>
                                    </span>
                                </td>
                                <td class="text-center" style="width:1em">
                                    <span
                                        class="badge"
                                        :class="p.expired ? 'badge-warning' : 'badge-green'"
                                        >{{ p.expired }}
                                    </span>
                                </td>
                                <td class="text-center" v-if="userEditRight">
                                    <button v-tooltip="'Edit Package'" type="button" @click="editPackage(p)"
                                        class="btn btn-sm btn-info m-1">
                                        <em class="fa fa-edit fa-fw"></em>
                                    </button>
                                    <button v-tooltip="'Delete Package'" type="button" @click="deletePackage(p)"
                                        class="btn btn-sm btn-primary">
                                        <em class="fa fa-trash fa-fw"></em>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="alert alert-info col-md-12">No price packages to display</div>
            </div>
        </div>
        <ModifyDeviceManagementPackageModal
          ref="addPackage"
          :pricePackage="newPricePackage"
          @packageAdded="createPackage"
          @packageEdited="savePackage"
        />
        <AddPriceModal ref="addPriceModal" :row-price="rowPrice" :new-price="newPriceObj"
            :package-description="packageDescription"
            @addPrice="addPrice" @pricesAdded="getPackages()" />
    </div>
</template>

<script>
  import AddPriceModal from '@/components/Admin/Modals/AddPriceModal'
  import ModifyDeviceManagementPackageModal from '@/components/Admin/Modals/ModifyDeviceManagementPackageModal'
  import PricingFilterToolbar from '@/components/Admin/PricingFilterToolbar'
  import PriceFunctions from './PriceFunctions'

  export default {
    extends: PriceFunctions,
    components: {
      AddPriceModal,
      ModifyDeviceManagementPackageModal,
      PricingFilterToolbar
    },
    props: {
      productNumber: {
        type: Number,
        required: true
      },
      userEditRight: {
        type: Boolean,
        required: true
      },
    },
    data() {
      return {
        period: this.getCurrentPeriod(),
        newPriceObj: {},
        newPricePackage: {},
        rowPrice: [],
        allPackages: [],
        packageDescription: '',
        expiredFilter: 'false',
        searchTerm: '',
      }
    },
    mounted() {
      this.getPackages();
    },
    computed: {
      packages() {
        let filteredPackages = this.allPackages;

        if (this.expiredFilter === 'false') {
          filteredPackages = filteredPackages.filter((pkg) => pkg.expired === false);
        } else if (this.expiredFilter === 'true') {
          filteredPackages = filteredPackages.filter((pkg) => pkg.expired === true);
        }

        if (this.searchTerm) {
          const normalizedSearchTerm = this.searchTerm.toLowerCase();
          filteredPackages = filteredPackages.filter((pkg) =>
            [pkg.label, pkg.description]
              .filter(Boolean)
              .some((value) => value.toLowerCase().includes(normalizedSearchTerm))
          );
        }

        return filteredPackages;
      }
    },
    methods: {
      getPackages() {
        this.$http.get(this.$config.aimsAPI + 'pricing/packages/product/' + this.productNumber + "/DeviceManagementPackage")
          .then(response => {
              this.allPackages = response.data;
            },
            error => {
              this.showError('Error fetching Packages', error)
              console.error(error);
            });
      },
      openPriceModal(p) {
        this.rowPrice = this.deepCopyObject(p.prices);
        this.packageDescription = p.description || '';
        this.newPriceObj = this.deepCopyObject({
          deviceManagementPackageNumber: p.deviceManagementPackageNumber,
          class: p.class + 'Price',
          validFrom: 0,
          validUntil: 0
        });  
        
        this.newPriceObj.setupfee = 0.00,
        this.$refs.addPriceModal.open();
      },
      addPrice(newPriceParam) {
        this.rowPrice.forEach(price => {
          if (price.validUntil == 0) {
            if (newPriceParam.validFrom % 100 > 1) {
              price.validUntil = newPriceParam.validFrom - 1;
            } else {
              price.validUntil = (newPriceParam.validFrom - 100) + 11;
            }
          }
        });
        this.rowPrice.push(newPriceParam);
        this.newPriceObj = this.deepCopyObject({
          deviceManagementPackageNumber: newPriceParam.deviceManagementPackageNumber,
          class: newPriceParam.class,
          validFrom: 0,
          validUntil: 0
        });
        this.newPriceObj.setupfee = 0.00;  
      },
      addPackage() {
        this.$http.get(this.$config.aimsAPI + 'pricing/new/package/za.co.adept.aims.device.DeviceManagementPackage')
            .then(response => {
                this.newPricePackage = response.data;
                this.newPricePackage.productNumber = this.productNumber;
            },
            error => {
                this.showError('Error getting new package template', error)
                console.error(error);
            });
        this.$refs.addPackage.open();
      },
      editPackage(pricePackage) {
        this.newPricePackage = pricePackage;
        this.$refs.addPackage.open();
      },
      createPackage(pricePackage) {
        this.$http.post(this.$config.aimsAPI + 'pricing/packages/create', pricePackage)
            .then(response => {
              this.getPackages();
              response.data.prices = [];
              this.openPriceModal(response.data);
              this.showSuccess('Created Package Successfully')
            },
            error => {
              this.showError('Error updating Packages', error)
              console.error(error);
            })
      },
      savePackage(pricePackage) {
          this.$http.put(this.$config.aimsAPI + 'pricing/packages/update', pricePackage)
            .then(response => {
              this.showSuccess('Updated Packages Successfully')
            },error => {
              this.showError('Error updating Packages', error)
              console.error(error);
            }).finally(() => {
              this.getPackages();
              this.$refs.addPackage.close();
            });
      },
      deletePackage(pricePackage) {
        this.$swal({
          title: 'Are you sure you want to delete this package?',
          text: pricePackage.description,
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then(result => {
          if (result.value) {
            this.$http.delete(
                this.$config.aimsAPI + 
                'pricing/pricepackages/' + 
                pricePackage.objKey +
                "?objClassName=" +
                pricePackage.class)
              .then(response => {
                  this.showSuccess('Successfully deleted Package');
                  this.getPackages();
                },
                error => {
                  this.showError('Error deleting Package', error)
                  console.error(error);
                });
          }
        })
      }
    }
  }

</script>
